@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../app-brand/entities/entity-layer.module.less';

.header-sku {
  color: var(--gray-919EAB);
  font-size: 0.67em;
  font-weight: 400;
  margin-left: @space-8;
}

.flex-row {
  flex-wrap: nowrap;
}

.flex-column {
  width: 100%;
}

/* Conversion summary preview */
.conversion-preview {
  font-size: 13px;
  color: var(--gray-637381);
  padding: @space-8 @space-12;
  background: var(--gray-F4F6F8);
  border-radius: 4px;
  border: 1px solid var(--gray-CFD1D3);
}

/* Section header: label inline with a trailing hairline */
.section-header {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.section-label {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--gray-637381);
}

.section-rule {
  flex: 1;
  height: 1px;
  background: var(--gray-CFD1D3);
}

/* Quantity NumberInput — match SimpleDropdown's natural height */
.quantity-input {
  min-height: 36px;
}

/* Dimension columns — allow shrinking so arrows don't overflow the modal */
.dimension-column {
  flex: 1 1 0;
  min-width: 0;
}

/* Identifiers row — top-align so barcode doesn't stretch when SKU gets a message */
.identifiers-row {
  align-items: flex-start;
}

/* Dimensions inputs */
.weight-input {
  width: 100%;
}

.weight-input-inner {
  width: 100%;
}

.weight-number-input {
  flex: 1;
  min-width: 0;
}

.weight-number-input-input {
  flex: 1;
  min-width: 0;
}

/* Info icon next to a field label */
.label-info-icon {
  display: inline-block;
  line-height: 0;
  margin-left: @space-4;
  color: var(--gray-637381);
  font-size: 12px;
  vertical-align: baseline;
  cursor: default;
}

/* Saving overlay */
.saving-overlay {
  opacity: 0.55;
  pointer-events: none;
}

/* Loading centered in modal body */
.modal-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

/* Contains dropdown disabled option hint */
.contains-option-hint {
  color: var(--gray-919EAB);
  font-weight: 400;
  margin-left: @space-4;
}

/* Save error inline */
.save-error {
  margin-top: @space-8;
}
